export const getPageIndex = (listConfig) => {
  return (listConfig?.startIndex / listConfig?.pageSize) || 0
}